import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal, Form, Tabs, Tab, Button, Card, Badge, InputGroup, FormControl, Dropdown, DropdownButton } from "react-bootstrap";
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";
import "../componentCss/healthcare-modern.css";
import toast, { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import {
  getStaffListAction,
  getFormListWithPermissionAction,
  updateFormsPermissionAction,
  getPatientListAction,
  assignPatientAction,
  getAssignedPatientListAction,
  updateStaffStatusAction,
  getStaffActivityLogsListAction
} from "../../Action/modernAdminActions";
import { useMigrationHelper, createMigratedAction } from '../../utils/migrationHelper';
import Swal from "sweetalert2";

import ReactToPrint, { useReactToPrint } from "react-to-print";
import { MdEdit } from "react-icons/md";
import { AiOutlineCalendar } from "react-icons/ai";
import { FaEye, FaUserPlus, FaUsers, FaUserShield, FaUserCog } from "react-icons/fa";
import { BsPersonAdd, BsSearch, BsX } from "react-icons/bs";
import { IoPerson, IoPrintSharp } from "react-icons/io5";
import { decryptData } from './decrypt';
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { IoMdSettings } from "react-icons/io";

const StaffManagement = () => {
  const { useModernAPI } = useMigrationHelper();

  // Create migrated actions
  const migratedGetStaffListAction = createMigratedAction('getStaffListAction');
  const migratedUpdateStaffStatusAction = createMigratedAction('updateStaffStatusAction');
  const migratedGetFormListWithPermissionAction = createMigratedAction('getFormListWithPermissionAction');
  const migratedUpdateFormsPermissionAction = createMigratedAction('updateFormsPermissionAction');
  const migratedGetPatientListAction = createMigratedAction('getPatientListAction');
  const migratedAssignPatientAction = createMigratedAction('assignPatientAction');
  const migratedGetAssignedPatientListAction = createMigratedAction('getAssignedPatientListAction');
  const migratedGetStaffActivityLogsListAction = createMigratedAction('getStaffActivityLogsListAction');

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAccessAllPatient, setIsAccessAllPatient] = useState(0);
  const [staffList, setStaffList] = useState([]);
  const [patientFilterData, setPatientFilterData] = useState({ 'name': '', 'location': '' });
  const [patientList, setPatientList] = useState([]);
  const [patientListByFilter, setPatientListByFilter] = useState([]);
  const [formList, setFormList] = useState([]);
  const [isModelOpen, setIsOpen] = useState(false);
  const [staffId, setStaffId] = useState(0);
  const [isLaoding, setisLaoding] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [isModelView, setIsModelView] = useState(false);
  const [isModelAssignPatient, setIsModelAssignPatient] = useState(false);
  const [viewData, setViewData] = useState({});
  const [staffActivityLogs, setStaffActivityLogs] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [details, setDetails] = useState({ fromDate: '', toDate: '', status: 'all', name: '', department: '', role: '' });
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const allDataRef = useRef();
  const singleRowRef = useRef();
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    recentlyAdded: 0
  });

  const handlePageChange = (page) => {
    console.log('=== PAGE CHANGE TRIGGERED ===');
    console.log('New page (DataTable):', page);
    console.log('Setting currentPage to:', page - 1);
    console.log('Previous currentPage:', currentPage);
    setCurrentPage(page - 1);
  };

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
    setShowBulkActions(state.selectedRows.length > 0);
  };

  const clearSelectedRows = () => {
    setSelectedRows([]);
    setShowBulkActions(false);
  };

  const handleBulkStatusUpdate = async (status) => {
    if (selectedRows.length === 0) return;

    const statusText = status === 1 ? 'activate' : 'deactivate';
    const result = await Swal.fire({
      title: 'Bulk Action Confirmation',
      text: `Are you sure you want to ${statusText} ${selectedRows.length} staff members?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${statusText} them!`
    });

    if (result.isConfirmed) {
      try {
        const promises = selectedRows.map(row =>
          migratedUpdateStaffStatusAction({ id: row.id, status })
        );
        await Promise.all(promises);
        toast.success(`Successfully ${statusText}d ${selectedRows.length} staff members`);
        clearSelectedRows();
        getStaffListAPI(true);
      } catch (error) {
        toast.error(`Failed to ${statusText} staff members`);
      }
    }
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (value == 'all') {
      const ids = patientListByFilter.map(item => item.recordId);
      if (selectedOptions.length === ids.length) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions(ids);
      }
    } else {
      setSelectedOptions(prev =>
        prev.includes(value) ? prev.filter(option => option !== value) : [...prev, value]
      );
    }
  };

  // const handleCheckboxChangeForAllPatient = (event) => {
  //   const value = event.target.value;
  //   setIsAccessAllPatient(isAccessAllPatient == 1 ? 0 : 1)
  // };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage)
  };
  useEffect(() => {
    getStaffListAPI();
  }, []);

  // Debug: Log staffList changes
  useEffect(() => {
    if (staffList.length > 0) {
    }
  }, [staffList]);

  const [searchTerm, setSearchTerm] = useState('');

  const filteredFormList = (Array.isArray(formList) ? formList : []).filter((data) =>
    data.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    setSelectedRow(null);
  }, [currentPage]);


  const staffActivityLogsAPI = async (id) => {
    let res = await migratedGetStaffActivityLogsListAction({ id: id });
    if (res.success) {
      setStaffActivityLogs(res.data)
    } else {
      setStaffActivityLogs([])
    }
  }

  // handleChange function removed - no longer needed for direct permission assignment
  // Users should only receive permissions through role assignments


  const deleteForm = async (data) => {
    let msg = ``;
    let status = 0;
    if (!data.is_active) {
      msg = `You want to activate this staff?`
      status = 1
    } else {
      msg = `You want to deactivate this staff?`
      status = 0
    }

    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await migratedUpdateStaffStatusAction({ 'id': data.id, 'status': status });
        if (res.success) {
          getStaffListAPI(true);
          toast.success(res.msg || res.message || "Staff status updated successfully");
        } else {
          toast.error(res.msg || res.message || "Failed to update staff status");
        }
      }
    });
  };


  const handleClose = () => setIsOpen(false);

  // Role assignment handler (replaces permission assignment)
  const handleOpenRoleAssignment = (user) => {
    // This should open a role assignment modal instead of permission modal
    // Implementation will be added when RoleAssignmentModal is created
    toast("Role assignment functionality will be implemented in UserPermissions component", {
      icon: 'ℹ️',
      style: {
        borderRadius: '10px',
        background: '#333',
        color: '#fff',
      },
    });
  };

  const handleOpenEditView = (id) => {
    setStaffId(id);
    // getFormListAPI(id); // Removed - no longer needed for permission assignment
  };
  const handleViewClose = () => setIsModelView(false);
  const handleOpenView = (data) => {
    setViewData(data);
    staffActivityLogsAPI(data.id);
    setIsModelView(true);
  };
  const handleOpenAssignPatient = async (data) => {
    setStaffId(data.id);
    let res = await migratedGetPatientListAction();
    if (res.success) {
      setPatientList(res.data);
      setPatientListByFilter(res.data);
    }
    let res2 = await migratedGetAssignedPatientListAction({ staff_id: data.id });
    if (res2.success) {
      let ids = res2.data.map(item => item.id);
      setSelectedOptions(ids);
      setIsAccessAllPatient(res2.is_all_patient_accessible);
    }
    setIsModelAssignPatient(true);
  };
  const handleViewCloseAssignPatient = () => {
    setStaffId(0);
    setPatientList([]);
    setPatientListByFilter([]);
    setSelectedOptions([]);
    setIsOpen(false);
    setIsModelAssignPatient(false);
  };
  // getFormListAPI function removed - no longer needed for direct permission assignment
  // Users should only receive permissions through role assignments

  const getStaffListAPI = async (isPagination = false) => {
    if (isPagination) {
      setPaginationLoading(true);
    } else {
      setIsLoading(true);
    }
    try {
      const apiParams = { 
        page: currentPage + 1, 
        page_size: rowsPerPage 
      };
      
      // Debug: Log pagination state and parameters
      console.log('=== PAGINATION DEBUG ===');
      console.log('currentPage state:', currentPage);
      console.log('rowsPerPage:', rowsPerPage);
      console.log('API Request Parameters:', apiParams);
      
      const res = await migratedGetStaffListAction(apiParams);
      
      // Debug: Log response to see if backend is respecting page_size
      console.log('API Response - items count:', res.data?.items?.length || res.data?.length);
      console.log('API Response - total:', res.data?.meta?.total || res.total);
      
      if (res.success) {
        // Handle both transformed and untransformed response structures
        const items = res.data?.items || res.data; // Extract items array
        const total = res.data?.meta?.total || res.total || (Array.isArray(items) ? items.length : 0); // Extract total count
        
        if (Array.isArray(items)) {
          setStaffList(items);
          setTotalRows(total);
          updateStaffStats(items);
          
          console.log(`Backend returned ${items.length} items of ${total} total`);
          console.log('First item ID:', items[0]?.id);
          console.log('Last item ID:', items[items.length - 1]?.id);
        } else {
          setStaffList([]);
          setTotalRows(0);
          toast.error("Invalid response format from server");
        }
      } else {
        setStaffList([]);
        setTotalRows(0);
        toast.error(res.message || "Failed to fetch staff list.");
      }
    } catch (error) {
      setStaffList([]);
      setTotalRows(0);
      toast.error("Failed to fetch staff list.");
    } finally {
      if (isPagination) {
        setPaginationLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  const updateStaffStats = (staffData) => {
    const active = staffData.filter(staff => staff.is_active).length;
    const inactive = staffData.filter(staff => !staff.is_active).length;
    const recentlyAdded = staffData.filter(staff => {
      const createdDate = new Date(staff.created_at || staff.createdAt);
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      return createdDate >= weekAgo;
    }).length;

    setStats({
      total: staffData.length,
      active,
      inactive,
      recentlyAdded
    });
  };

  let getStaffListAPIForFilter = async (isPagination = false) => {
    if (isPagination) {
      setPaginationLoading(true);
    } else {
      setIsLoading(true);
    }
    try {
      // Use migrated action and pass search parameters
      let res = await migratedGetStaffListAction({
        page: currentPage + 1,
        page_size: rowsPerPage,
        search: details.name,
        is_active: details.status !== 'all' ? (details.status === '1') : undefined,
        department: details.department || undefined,
        role: details.role || undefined,
        fromDate: details.fromDate,
        toDate: details.toDate
      });
      
      // Debug: Log response to see if backend is respecting page_size
      console.log('Filter API Response - items count:', res.data?.items?.length || res.data?.length);
      console.log('Filter API Response - total:', res.data?.meta?.total || res.total);
      
      if (res.success) {
        // Handle both transformed and untransformed response structures
        const items = res.data?.items || res.data; // Extract items array
        const total = res.data?.meta?.total || res.total || (Array.isArray(items) ? items.length : 0); // Extract total count
        
        if (Array.isArray(items)) {
          setStaffList(items);
          setTotalRows(total);
          updateStaffStats(items);
          
          console.log(`Filter backend returned ${items.length} items of ${total} total`);
          console.log('Filter first item ID:', items[0]?.id);
          console.log('Filter last item ID:', items[items.length - 1]?.id);
        } else {
          setStaffList([]);
          setTotalRows(0);
          toast.error("Invalid response format from server");
        }
      } else {
        setStaffList([]);
        setTotalRows(0);
        toast.error(res.message || "Failed to filter staff list.");
      }
    } catch (error) {
      setStaffList([]);
      setTotalRows(0);
      toast.error("An error occurred while filtering the staff list.");
    } finally {
      if (isPagination) {
        setPaginationLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  const resetStaffListFilter = () => {
    setDetails({
      name: '',
      status: 'all',
      department: '',
      role: '',
      fromDate: '',
      toDate: ''
    });
    setShowAdvancedFilters(false);
    getStaffListAPI(); // Load all staff without filters
  };

  const searchByNameHandler = (e) => {
    const { name, value } = e.target;
    setDetails((old) => {
      return { ...old, [name]: value };
    });
  };

  const searchPatientHandler = (e) => {
    const { name, value } = e.target;
    setPatientFilterData((old) => {
      return { ...old, [name]: value };
    });
  };

  // submitPermissionForm function removed - no longer needed for direct permission assignment
  // Users should only receive permissions through role assignments

  let assignPatientSubmit = async (e) => {
    e.preventDefault();
    let res = await migratedAssignPatientAction({ staff_id: viewData.id, patientIds: selectedOptions, 'isAccessAllPatient': isAccessAllPatient });
    if (res.success) {
      toast.success(res.msg);
      setIsModelAssignPatient(false);
      setSelectedOptions([]);
    } else {
      toast.error(res.msg);
    }
  };

  const columns = [
    {
      name: "#",
      cell: (row, index, column, id) => {
        return index + 1 + currentPage * rowsPerPage;
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Name",
      selector: (row) => row.full_name || `${row.first_name || ''} ${row.last_name || ''}`.trim(),
      sortable: true,
      width: "15%"
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "30%"
    },
    {
      name: 'Roles',
      cell: (row) => (
        <div className="d-flex flex-wrap">
          {row.roles && row.roles.length > 0 ? (
            row.roles.map((role, index) => (
              <span key={index} className="healthcare-status-badge healthcare-status-active me-1 mb-1">
                {role}
              </span>
            ))
          ) : (
            <span className="healthcare-status-badge healthcare-status-inactive">
              No Roles
            </span>
          )}
        </div>
      ),
      sortable: true,
      width: '30%',
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex gap-2">
          <Link to={`${config.baseUrl}edit-staff/${row.id}`}>
            <button
              title="Edit Staff"
              className="healthcare-action-btn healthcare-action-edit"
            >
              <MdEdit size={14} />
              Edit Staff
            </button>
          </Link>
          <button
            onClick={() => deleteForm(row)}
            title={row.is_active ? "Deactivate" : "Activate"}
            className={`healthcare-action-btn ${row.is_active ? 'healthcare-action-danger' : 'healthcare-action-success'}`}
          >
            {row.is_active ?
              <BsToggleOff size={14} /> :
              <BsToggleOn size={14} />
            }
            {row.is_active ? "Deactivate" : "Activate"}
          </button>
        </div>
      ),
      sortable: true,
      width: "20%"
    },
  ];

  const printColumns = [
    {
      name: "#",
      cell: (row, index, column, id) => {
        return index + 1 + currentPage * 10;
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row.mobileNumber,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.userGroup,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) =>
        row.isActive == 1 ? (
          <p className="text-primary">Active</p>
        ) : (
          <span className="text-danger">Inactive</span>
        ),
      sortable: true,
    },
  ];

  const printAllData = useReactToPrint({
    content: () => allDataRef.current,
  });

  const handlePrint = (row) => {
    setSelectedRow(row);
    setTimeout(() => {
      handlePrintSingle();
    }, 100);
  };
  const handlePrintSingle = useReactToPrint({ content: () => singleRowRef.current });

  const handlePrintAll = useReactToPrint({ content: () => allDataRef.current });

  const getPatientByLocation = async () => {
    let res = await migratedGetPatientListAction({ location: patientFilterData.location });
    if (res.success) {
      setPatientListByFilter(res.data)
    } else {
      setPatientListByFilter([])
    }
  }

  const getPatientByName = async () => {
    let res = await migratedGetPatientListAction({ name: patientFilterData.name });
    if (res.success) {
      setPatientListByFilter(res.data)
    } else {
      setPatientListByFilter([])
    }
  }

  const resetLocationFilter = () => {
    setPatientFilterData({ ...patientFilterData, location: '' });
    getPatientByLocation()
  }

  const searchPatientByLocation = () => {
    getPatientByLocation()
  }

  const resetNameFilter = () => {
    setPatientFilterData({ ...patientFilterData, name: '' });
    getPatientByName()
  }

  const searchPatientByName = () => {
    getPatientByName()
  }

  // Server-side pagination - no client-side slicing needed

  // Pagination and filter changes effect
  useEffect(() => {
    console.log('=== USEEFFECT PAGINATION TRIGGER ===');
    console.log('currentPage:', currentPage);
    console.log('rowsPerPage:', rowsPerPage);
    console.log('staffList.length:', staffList.length);
    
    // Skip initial render (handled by initial load useEffect)
    if (currentPage === 0 && rowsPerPage === 10 && staffList.length === 0) {
      console.log('Skipping initial render');
      return;
    }
    
    // Check if filters are active
    const hasActiveFilters = details.name || details.status !== 'all' || details.department || details.role || details.fromDate || details.toDate;
    console.log('hasActiveFilters:', hasActiveFilters);
    
    if (hasActiveFilters) {
      console.log('Calling getStaffListAPIForFilter with pagination');
      // Use filter API with pagination loading for smooth UX
      getStaffListAPIForFilter(true);
    } else {
      console.log('Calling getStaffListAPI with pagination');
      // Use basic API with pagination loading for smooth UX
      getStaffListAPI(true);
    }
  }, [currentPage, rowsPerPage, details.name, details.status, details.department, details.role, details.fromDate, details.toDate]);

  return (
    <>
      {/* <Dashboardheader />
      <Toaster /> */}
      {/* <div className="wrapper">
        <Sidebar /> */}
      <div id="content" className="healthcare-container">
        <Container fluid className="p-4">
          <Row>
            <Col lg={12} md={12} sm={12} className="">
              <div className="healthcare-card">
                <div className="healthcare-header">
                  <h5>
                    <FaUserShield size={24} />
                    Staff Management
                  </h5>
                  <div className="subtitle">
                    Manage staff members, roles, and permissions
                  </div>
                </div>
                <div className="p-4">
                  <div className="healthcare-table-header">
                    <div className="healthcare-table-title">
                      <FaUsers />
                      Staff Management
                    </div>
                    <div className="healthcare-table-subtitle">
                      Manage system users and their access permissions
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12} md={12} sm={12} className="mt-3">
              <div className="d-flex justify-content-end align-align-items-end">
                <Link to={`${config.baseUrl}add-staff`}>
                  <button className="healthcare-btn healthcare-btn-primary">
                    <FaUserPlus size={16} />
                    Add Staff
                  </button>
                </Link>
              </div>
              <div className="healthcare-card mt-4">
                <div className="p-4">
                  <div className="healthcare-table-header">
                    <div className="d-flex align-items-center gap-3 flex-grow-1">
                      <div className="healthcare-search-container">
                        <input
                          type="text"
                          className="healthcare-search-input"
                          placeholder="Search by name..."
                          name="name"
                          value={details.name}
                          onChange={searchByNameHandler}
                        />
                      </div>
                    </div>
                    <div className="healthcare-table-actions">
                      <div className="d-flex gap-2">
                        <select
                          className="healthcare-select"
                          name="status"
                          value={details.status}
                          onChange={searchByNameHandler}
                        >
                          <option value="all">All Status</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                        <button
                          className="healthcare-btn healthcare-btn-secondary"
                          onClick={resetStaffListFilter}
                        >
                          Reset
                        </button>
                        <button
                          className="healthcare-btn healthcare-btn-primary"
                          onClick={getStaffListAPIForFilter}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="healthcare-table-container mt-4">

                {isLoading && !paginationLoading ? (
                  <div className="healthcare-loading">
                    <div className="healthcare-loading-spinner"></div>
                    <div className="healthcare-loading-text">Loading staff...</div>
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    data={Array.isArray(staffList) ? staffList : []}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={rowsPerPage}
                    paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
                    paginationComponentOptions={{
                      rowsPerPageText: 'Rows per page:',
                      rangeSeparatorText: 'of',
                    }}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    progressPending={paginationLoading}
                    progressComponent={
                      <div className="d-flex justify-content-center align-items-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="ms-2">Loading staff data...</span>
                      </div>
                    }
                    noDataComponent={
                      <div className="healthcare-loading">
                        <FaUsers size={48} className="text-muted mb-3" />
                        <div className="healthcare-loading-text text-muted">
                          No staff found
                        </div>
                      </div>
                    }
                  />
                )}
              </div>
              {/*------------------------------- Section For Showing All Data For Print--------------------------------------------------- */}

              <div style={{ display: 'none' }}>
                <div ref={allDataRef}>
                  <center>
                    <h2 className=''> User Management List</h2>
                  </center>
                  <DataTable
                    columns={printColumns}
                    data={Array.isArray(staffList) ? staffList : []}
                    pagination={false}
                  />
                </div>
              </div>
              {/*------------------------------- Section For Showing Single Data For Print--------------------------------------------------- */}

              <div style={{ display: 'none' }}>
                <div className="card-body" ref={singleRowRef} style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '10px', margin: '20px', fontFamily: 'Arial, sans-serif' }}>
                  {selectedRow && (
                    <div style={{ textAlign: 'left', lineHeight: '1.5' }}>
                      <h2 className="card-title" style={{ textAlign: 'center', marginBottom: '20px' }}>User Management List</h2>
                      <p><strong>ID:</strong> {selectedRow.id}</p>
                      <p><strong>First Name:</strong> {selectedRow.firstName}</p>
                      <p><strong>Last Name:</strong> {selectedRow.lastName}</p>
                      <p><strong>City:</strong> {selectedRow.city}</p>
                      <p><strong>Address:</strong> {selectedRow.address}</p>
                      <p><strong>Designation:</strong> {selectedRow.designation}</p>
                      <p><strong>Employee Id:</strong> {selectedRow.employeeId}</p>
                      <p><strong>Gender:</strong> {selectedRow.gender}</p>
                      <p><strong>Date Of Joining:</strong> {selectedRow.DateOfJoining}</p>
                      <p><strong>Licence Number:</strong> {selectedRow.licenceNumber}</p>
                      <p><strong>Mobile Number:</strong> {selectedRow.mobileNumber}</p>
                      <p><strong>User Group:</strong> {selectedRow.userGroup}</p>
                      <p><strong>Image:</strong>
                        {selectedRow.photo ? (
                          <>
                            <img width="100" src={selectedRow.photo}></img>
                            <br />
                          </>
                        ) : (
                          ""
                        )}</p>
                      <p><strong>Signature:</strong>
                        {selectedRow.signature ? (
                          <>
                            <img width="100" src={selectedRow.signature}></img>
                            <br />
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                      <p><strong>Stamp Image:</strong>
                        {selectedRow.stampImage ? (
                          <>
                            <img width="100" src={selectedRow.stampImage}></img>
                            <br />
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                      <p><strong>Status:</strong> {selectedRow.status == 1 ? 'Active' : 'Inactive'}</p>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>


          {/* Permission Modal Removed - Use Role Assignment Only */}
          {/* Direct permission assignment has been removed to enforce RBAC principles */}
          {/* Users should only receive permissions through role assignments */}

          {/* Assign form to staff */}
          <Modal
            show={isModelView}
            onHide={() => handleViewClose(false)}
            dialogClassName="modal-90w modal-right modal-lg"
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <b>View Staff Details</b>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Tabs defaultActiveKey="basicInfo" id="uncontrolled-tab-example" className="mb-3">
                {/* Tab 1: Basic Information */}
                <Tab eventKey="basicInfo" title="Basic Information">
                  <ul className="list-group">
                    <li className="list-group-item d-flex flex-row " >
                      <div className="w-50">
                        <strong className="staffView w-50">First Name:</strong>{" "}
                      </div>

                      {viewData?.namePrefix}{" "}
                      {viewData?.firstName ? viewData?.firstName : "NA"}
                    </li>
                    <li className="list-group-item d-flex flex-row "  >
                      <div className="w-50">
                        <strong className="staffView">Middle Name:</strong>{" "}
                      </div>

                      {viewData?.middleName ? viewData?.middleName : "NA"}
                    </li>
                    <li className="list-group-item d-flex flex-row">

                      <div className="w-50">
                        <strong className="staffView">Last Name:</strong>{" "}
                      </div>

                      {viewData?.lastName ? viewData?.lastName : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Employee ID:</strong>{" "}
                      </div>

                      {viewData?.employeeId ? viewData?.employeeId : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Email:</strong>{" "}
                      </div>

                      {viewData?.email ? viewData?.email : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Mobile Number:</strong>{" "}
                      </div>

                      {viewData?.mobileNumber ? viewData?.mobileNumber : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">City:</strong>{" "}
                      </div>

                      {viewData?.city ? viewData?.city : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Address:</strong>{" "}
                      </div>

                      {viewData?.address ? viewData?.address : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">State:</strong>{" "}
                      </div>
                      {viewData?.state ? viewData?.state : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Emirates ID number:</strong>{" "}
                      </div>
                      {viewData?.emiratesIdNumber
                        ? viewData?.emiratesIdNumber
                        : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Gender:</strong>{" "}
                      </div>
                      {viewData?.gender == 1
                        ? "Male"
                        : viewData?.gender == 2
                          ? "Female"
                          : "Other"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Designation:</strong>{" "}
                      </div>
                      {viewData?.designation ? viewData?.designation : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Role:</strong>{" "}
                      </div>

                      {viewData?.userGroup ? viewData?.userGroup : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Stamp Image:</strong>
                      </div>
                      {viewData.stampImage ? (
                        <>
                          <img width="100" src={viewData.stampImage}></img>
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Photo:</strong>
                      </div>
                      {viewData.photo ? (
                        <>
                          <img width="100" src={viewData.photo}></img>
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Signature:</strong>
                      </div>
                      {viewData.signature ? (
                        <>
                          <img width="100" src={viewData.signature}></img>
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">Date of joining:</strong>
                      </div>
                      {viewData?.DateOfJoining ? viewData?.DateOfJoining : "NA"}
                    </li>

                    <li className="list-group-item d-flex flex-row">
                      <div className="w-50">
                        <strong className="staffView">License Number:</strong>{" "}
                      </div>

                      {viewData?.licenceNumber ? viewData?.licenceNumber : "NA"}
                    </li>
                  </ul>
                </Tab>
                <Tab eventKey="logHistory" title="Log History">
                  <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Updated By</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {staffActivityLogs && staffActivityLogs.length > 0 ? (
                          staffActivityLogs.map((log, index) => (
                            <tr key={index}>
                              <td>{log.firstName + ' ' + log.middleName + ' ' + log.lastName}</td>
                              <td>{log.status == 0 ?
                                <p style={{ color: "green" }}>Active</p> :
                                <p style={{ color: "red" }}>Deactive</p>

                              }</td>
                              <td>{log.datetime}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                              No log history available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Tab>

              </Tabs>
            </Modal.Body>
          </Modal>

          {/* Assign patient to staff */}
          <Modal
            show={isModelAssignPatient}
            onHide={() => handleViewCloseAssignPatient(false)}
            dialogClassName="modal-90w modal-right modal-lg"
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <b>Assign Patient</b>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <div className="">
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="name">Patient Location:</label>&nbsp;
                    <input
                      type="text"
                      name="location"
                      className="form-control"
                      placeholder="Enter Location..."
                      value={patientFilterData.location}
                      onChange={searchPatientHandler}
                    />
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="name">Patient Name:</label>&nbsp;
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Name..."
                      value={patientFilterData.name}
                      onChange={searchPatientHandler}
                    />
                  </div>

                  <div className="col-md-4">
                    <button
                      className="px-3 py-2 btn-sm btn-secondary-btn3 fs-6 mt-4"
                      onClick={resetLocationFilter}
                    >
                      Reset
                    </button>
                    &nbsp;
                    <button
                      className="px-3 py-2 btn-sm btn-secondary-btn3 fs-6 mt-4"
                      onClick={searchPatientByLocation}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>

              <ul className="list-group">
                <li className="list-group-item d-flex flex-row " >
                  <div className="w-50">
                    <strong className="staffView w-50">Staff Name:</strong>{" "}
                  </div>

                  {viewData?.namePrefix}{" "}
                  {viewData?.firstName ? viewData?.firstName : "NA"}
                </li>

                {/* <li className="list-group-item d-flex flex-row " >
                  <div className="w-50">
                    <strong className="staffView w-50">Is access all patient:</strong>
                  </div>
                  <input
                    type="checkbox"
                    value="1"
                    checked={isAccessAllPatient}
                    onChange={handleCheckboxChangeForAllPatient}
                  />
                </li> */}

                {isAccessAllPatient == 0 &&
                  <>
                    <li className="list-group-item d-flex flex-row " >
                      <div className="w-50">
                        <strong className="staffView w-50">Patient List:</strong>{" "}
                      </div>
                      <ul style={{ listStyleType: 'none', padding: 0, height: '300px', overflowX: 'auto' }}>
                        {patientListByFilter.length > 0 ?
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                value='all'
                                checked={selectedOptions.length === patientList.length}
                                onChange={handleCheckboxChange}
                              />
                              &nbsp; Select All
                            </label>
                          </li> : "No Patient found"}
                        {patientListByFilter.map(data => (
                          <li key={data.recordId}>
                            <label>
                              <input
                                type="checkbox"
                                value={data.recordId}
                                checked={selectedOptions.includes(data.recordId)}
                                onChange={handleCheckboxChange}
                              />
                              &nbsp; {`${data[1] ? data[1] : ''} ${data[2] ? data[2] : ''}(${data[1929] ? data[1929] : 'NA'})`}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </>
                }
                <li className="list-group-item d-flex flex-row " >
                  <div className="w-50">
                    <button className="px-3 py-2 btn-sm btn-secondary-btn3 fs-6" onClick={assignPatientSubmit}>Assign</button>
                  </div>
                </li>
              </ul>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
      {/* </div> */}
    </>
  );
};

export default StaffManagement;
